var GAME = new Adventure();

var gamedata = {
    items: {},
    characters: {},
    rooms: {}
};

gamedata.items.cassettaLatta = new Container({
    name: "cassetta di latta",
    description: "Una cassetta di latta tutta ammaccata. Qualcuno ci ha scritto sopra 'provviste e giudizi affrettati'.",
    articolo: "la",
    state: State.CLOSED,
    capacity: 6,
    volume: 3,
    items: [
        new Item({
            name: "biscotto al catrame",
            articolo: "un",
            description: "Un biscotto nerissimo, duro e profumato in modo minaccioso.",
            volume: 1
        }),
        new Item({
            name: "pezza unta",
            sinonimi: ["pezza", "straccio"],
            articolo: "una",
            description: "Una pezza sporca di grasso, muffa e trascorsi discutibili.",
            volume: 1
        }),
        new Item({
            name: "chiave inglese",
            articolo: "una",
            description: "Una chiave inglese pesante. Non aggiusta quasi nulla, ma convince parecchio.",
            volume: 1,
            attackPower: 3
        }),
        new Item({
            name: "fungo fosforescente",
            sinonimi: ["fungo"],
            articolo: "un",
            description: "Un fungo color verde radioattivo. Non ispira fiducia, ma nemmeno sobrietà.",
            volume: 1,
            onMangia: function() {
                GAME.write("Mangi il fungo fosforescente. Hai preso una pessima decisione, ma ti senti sorprendentemente meglio.");
                GAME.room.container.delete(this.name);
                GAME.player.getHealed(5);
            }
        })
    ]
});

gamedata.items.portafoglio = new Container({
    name: "portafoglio",
    description: "Un portafoglio slabbrato che contiene soprattutto rimpianti.",
    articolo: "il",
    state: State.OPEN,
    capacity: 0,
    volume: 0,
    items: [
        new Item({
            name: "banconota stropicciata",
            sinonimi: ["banconota"],
            articolo: "una",
            description: "Una banconota talmente stropicciata da sembrare una prova di sopravvivenza urbana.",
            volume: 0
        })
    ]
});

gamedata.items.cassaStagna = new Container({
    name: "cassa stagna",
    description: "Una cassa impermeabile nera, robusta e fin troppo orgogliosa della sua serratura.",
    articolo: "la",
    state: State.LOCKED,
    key: "Chiave Nera",
    capacity: 5,
    volume: 4,
    onBlocked: function() {
        return {
            text: "La cassa stagna non si apre. Pare che abbia più autostima di te."
        };
    },
    onOpen: function() {
        return {
            result: "OK",
            text: "La serratura cede con un tonfo umido e poco elegante."
        };
    },
    items: [
        new Item({
            name: "idolo dei tombini",
            sinonimi: ["idolo", "tesoro"],
            articolo: "l'",
            description: "Un idolo d'ottone con occhi di vetro e un'espressione da funzionario comunale eternamente deluso.",
            volume: 2,
            onTake: function() {
                GAME.write("Stringi l'idolo dei tombini fra le mani. Complimenti: hai trovato il tesoro della fogna maestra e, con ogni probabilità, una nuova serie di problemi.");
                return true;
            }
        }),
        new Item({
            name: "gettone del re delle fogne",
            sinonimi: ["gettone"],
            articolo: "un",
            description: "Un gettone d'ottone inciso. Non vale niente, quindi naturalmente ha un grande valore simbolico.",
            volume: 0
        })
    ]
});

gamedata.characters.madamaCesira = new Character({
    name: "Madama Cesira",
    sinonimi: ["madama", "cesira", "signora", "vecchia"],
    description: "Una dama delle fogne avvolta in una pelliccia che in teoria fu bianca. Ti guarda come se fossi entrato in salotto senza appuntamento nel secolo sbagliato.",
    articolo: "la",
    gender: Gender.FEMALE,
    maxHealth: 12,
    health: 12,
    attackPower: 2,
    defensePower: 2,
    met: false,
    satisfied: false,
    items: [
        new Item({
            name: "Chiave Rossa",
            articolo: "la",
            volume: 1
        }),
        new Item({
            name: "ventaglio velenoso",
            sinonimi: ["ventaglio"],
            articolo: "il",
            attackPower: 2,
            volume: 1
        })
    ],
    onMeet: function() {
        if (this.met) return;
        this.met = true;
        GAME.write("Madama Cesira ti squadra e sussurra: - Se sei qui per il tesoro, prendi il numerino. Se sei qui per salvarmi, temo tu sia in ritardo di vent'anni -");
    },
    onParla: function() {
        if (!this.satisfied) {
            GAME.write("Madama Cesira sospira con tragica competenza: - Mi servirebbe un biscotto al catrame. Senza, non riesco neanche a essere sprezzante come si deve -");
        } else {
            GAME.write("Madama Cesira ti concede un sorriso minimo: - La chiave rossa ce l'hai. Adesso vai dallo sgabuzzino, ma cerca di non ragionare troppo: lì sotto è mal visto -");
        }
    },
    onSaluta: function() {
        GAME.write("Madama Cesira inclina appena il capo: - Educazione, qui sotto? Che piacevole cedimento della civiltà -");
    },
    onReceive: function(item) {
        if (item.is("biscotto")) {
            if (!this.satisfied) {
                this.satisfied = true;
                this.container.give("Chiave Rossa", GAME.player.container);
                GAME.write("Madama Cesira addenta il biscotto al catrame con occhi lucidi: - Finalmente qualcosa all'altezza della mia tristezza. Tieni la chiave rossa. Il troll nello sgabuzzino si lascia persuadere solo da tessuti disgustosi -");
            } else {
                GAME.write("Madama Cesira accetta il biscotto con dignità professionale: - Un giorno scriveranno di noi. Male, ma scriveranno -");
            }
            return true;
        }

        GAME.write("Madama Cesira osserva " + item.nameWitharticle() + " e sospira: - Apprezzo il gesto, ma non ho ancora toccato quel livello di disperazione -");
        return false;
    },
    onAttack: function() {
        GAME.write("Madama Cesira schiocca il ventaglio con precisione notarile.");
        this.attack(GAME.player, this.container.get("ventaglio"));
    }
});

gamedata.characters.pappagalloIdraulico = new Character({
    name: "Pappagallo Idraulico",
    sinonimi: ["pappagallo", "volatile", "idraulico"],
    description: "Un pappagallo spelacchiato appollaiato su un tubo. Ti fissa con l'aria di chi ha visto troppe fatture e nessun pagamento.",
    articolo: "il",
    maxHealth: 6,
    health: 6,
    attackPower: 2,
    defensePower: 1,
    met: false,
    onMeet: function() {
        if (this.met) return;
        this.met = true;
        GAME.write("Il pappagallo idraulico gracchia: - Sciacqua! Firma! Scarica in triplice copia! -");
    },
    onParla: function() {
        GAME.write("Il pappagallo idraulico torce la testa e urla: - Preventivo! Preventivo! Nessun rimborso per danni da mostro! -");
    },
    onSaluta: function() {
        GAME.write("Il pappagallo ti saluta con un colpo di tosse e una frase fiscale incompleta.");
    },
    onAttack: function() {
        GAME.write("Il pappagallo idraulico ti becca con zelo amministrativo.");
        this.attack(GAME.player);
    }
});

gamedata.characters.trollGrondaie = new Character({
    name: "Troll delle Grondaie",
    sinonimi: ["troll", "mostro", "grondaie", "guardiano"],
    description: "Un colosso umido e scontroso armato di mazzuolo. Sembra scolpito nel fango e rifinito male.",
    articolo: "il",
    maxHealth: 14,
    health: 14,
    aggressive: true,
    attackPower: 4,
    defensePower: 1,
    met: false,
    pacified: false,
    items: [
        new Item({
            name: "Chiave Nera",
            articolo: "la",
            volume: 1
        }),
        new Item({
            name: "mazzuolo di gomma",
            sinonimi: ["mazzuolo"],
            articolo: "il",
            attackPower: 2,
            volume: 1
        })
    ],
    onMeet: function() {
        if (this.aggressive) {
            GAME.write("Dall'ombra emerge il Troll delle Grondaie: - Pedaggio! O panno lurido di pari valore! -");
            this.attack(GAME.player, this.container.get("mazzuolo"));
        } else if (!this.met) {
            GAME.write("Il Troll delle Grondaie annusa l'aria e grugnisce: - Siamo colleghi del degrado, ormai -");
        }
        this.met = true;
    },
    onParla: function() {
        if (this.aggressive) {
            GAME.write("Il troll ringhia: - Io parlo solo il dialetto degli stracci unti -");
        } else {
            GAME.write("Il troll si gratta il mento: - La cassa stagna si apre con la chiave nera. Sì, l'ho tenuta in tasca. No, non c'è un motivo nobile -");
        }
    },
    onSaluta: function() {
        if (this.aggressive) GAME.write("Il troll ti saluta alzando il mazzuolo. È un gesto sociale, ma sconsigliabile.");
        else GAME.write("Il troll fa un cenno grave: - Rispetto tra professionisti della muffa -");
    },
    onReceive: function(item) {
        if (item.is("pezza")) {
            if (!this.pacified) {
                this.pacified = true;
                this.aggressive = false;
                this.container.give("Chiave Nera", GAME.player.container);
                GAME.write("Il troll stringe la pezza unta al petto con sincera devozione: - Ah... tessile vissuto. Finalmente qualcuno che capisce il lusso. Tieni la chiave nera e va' a profanare la cassa stagna come un signore -");
            } else {
                GAME.write("Il troll annuisce soddisfatto: - Ottima pezza. Ha carattere. Ha profondità. Ha odore -");
            }
            return true;
        }

        GAME.write("Il troll scuote il capo: - No. Io tratto solo in porcherie tessili -");
        return false;
    },
    onAttack: function() {
        if (!this.aggressive) return;
        GAME.write("Il Troll delle Grondaie sbuffa e rialza il mazzuolo con disciplina sindacale.");
        this.attack(GAME.player, this.container.get("mazzuolo"));
    }
});

gamedata.rooms = [
    new Room({
        name: "Ingresso",
        description: "Sei all'ingresso della fogna maestra, una galleria di mattoni bagnati che sprofonda sotto la città. L'aria sa di ruggine, acqua stagnante e pessime decisioni.",
        items: [
            gamedata.items.cassettaLatta,
            new Item({
                name: "lanterna a carburo",
                sinonimi: ["lanterna"],
                articolo: "la",
                description: "Una lanterna vecchia ma ancora testarda. Fa una luce debole, però giudica tutti in modo eccellente.",
                volume: 2
            })
        ],
        gateways: {
            nord: new Gateway({
                name: "scale",
                articolo: "le",
                destination: "Salotto",
                description: "Una rampa di gradini viscidi porta verso un vano più ampio, dove si sente chiacchierare male di qualcuno.",
                actions: ["sali"]
            }),
            est: new Gateway({
                name: "porta rossa",
                articolo: "la",
                key: "Chiave Rossa",
                state: State.LOCKED,
                description: "Una porta metallica verniciata di rosso, macchiata di calcare e sospetto.",
                onOpen: function() {
                    GAME.write("La porta rossa si apre con un lamento metallico, come se avesse appena ricordato un torto del 1974.");
                    return true;
                },
                onBlocked: function() {
                    GAME.write("La porta rossa non si apre. Dal lato opposto sembra arrivare un respiro di pessimo umore.");
                    return false;
                },
                destination: "Sgabuzzino"
            })
        }
    }),
    new Room({
        name: "Salotto",
        description: "Una camera sotterranea sorprendentemente arredata: poltrone sfondate, tappeti umidi e tubature che attraversano il soffitto come un lampadario progettato da un idraulico depresso.",
        characters: [
            gamedata.characters.madamaCesira,
            gamedata.characters.pappagalloIdraulico
        ],
        items: [
            new Item({
                name: "divano spelacchiato",
                sinonimi: ["divano"],
                articolo: "il",
                description: "Un divano spelacchiato e nobile oltre ogni ragione. Probabilmente ha visto crollare governi e cene peggiori.",
                volume: 4
            })
        ],
        gateways: {
            sud: new Gateway({
                name: "scale",
                articolo: "le",
                destination: "Ingresso"
            })
        }
    }),
    new Room({
        name: "Sgabuzzino",
        description: "Uno stanzone tecnico allagato a metà, invaso da tubi, catene e cassette dimenticate. Ogni superficie sembra appiccicosa per ragioni autonome.",
        characters: [
            gamedata.characters.trollGrondaie
        ],
        items: [
            gamedata.items.cassaStagna,
            new Item({
                name: "pompa arrugginita",
                sinonimi: ["pompa"],
                articolo: "la",
                description: "Una pompa arrugginita grande come un vitello e altrettanto collaborativa.",
                volume: 5
            })
        ],
        gateways: {
            ovest: new Gateway({
                name: "porta rossa",
                articolo: "la",
                state: State.OPEN,
                destination: "Ingresso",
                onClose: function() {
                    GAME.write("La porta rossa si richiude con un tonfo che sembra un giudizio morale.");
                    return true;
                }
            })
        }
    })
];

gamedata.characters.player = new Character({
    name: "Pancrazio",
    maxHealth: 20,
    health: 20,
    attackPower: 4,
    defensePower: 3,
    player: true,
    capacity: 6,
    items: [
        gamedata.items.portafoglio
    ]
});

GAME.configure({
    name: "L'idolo dei tombini",
    player: gamedata.characters.player,
    rooms: gamedata.rooms,
    start: "Ingresso"
});
